// Environment configuration
export const config = {
  // Firebase Configuration - only used for web platform
  // Native platforms use google-services.json and GoogleService-Info.plist
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "your-api-key",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "your-auth-domain",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "your-project-id",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "your-storage-bucket",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "your-messaging-sender-id",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "your-app-id",
  },
  
  // VAPID Key for web push notifications
  vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || "your-vapid-key",
  
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000",
  },
  
  // App Configuration
  app: {
    name: "TightShip Mobile",
    version: "1.0.0",
    /** Minimum required app version for force upgrade (fallback if API fails). Set when you need to force users to upgrade. */
    minVersion: undefined as string | undefined,
    /** Play Store URL for the Android app (used by force upgrade screen). */
    androidStoreUrl: "https://play.google.com/store/apps/details?id=com.chasingmermaids.sawadone",
    /** Manager web app URL used for the "View reports" link in the sidebar. Falls back to external API base if not explicitly set. */
    managerAppUrl:
      import.meta.env.VITE_MANAGER_APP_URL || import.meta.env.VITE_EXTERNAL_API_BASE,
    /** Leave approvals page URL for opening pending leave requests from mobile app. */
    leaveApprovalsUrl:
      import.meta.env.VITE_LEAVE_APPROVALS_URL ||
      (import.meta.env.VITE_MANAGER_APP_URL || import.meta.env.VITE_EXTERNAL_API_BASE
        ? `${import.meta.env.VITE_MANAGER_APP_URL || import.meta.env.VITE_EXTERNAL_API_BASE}/leave-approvals`
        : ""),
  },
};
